<template>
  <div id="page-about" class="page">
    <div class="container">
      <section>
        <header class="header">市场层面</header>
        <p class="subtitle">Market level</p>
        <img src="/static/about-market.png"/>
        <div class="row market">
          <div class="col-sm">
            <p>弦熵科技目前是全球唯一可以售卖全类目商品的无人智能售货机，标品、半标品、非标品均可。早点豆浆、火锅连锁、米面粮油、果蔬生鲜、卤味酱货、坚果零食等等，无论是散装还是预包装，经营模式不再受品类限制。商品摆放形式也在近期有了新的技术突破，可叠层的补货方式增加大了柜体的容积使用率，降低运营商的补货成本与，坪效比倍增。应用于消费场景，市场前景无限可能。</p>
          </div>
          <div class="col-sm">
            <p>目前人工智能货柜行业的主要解决方案有四种：RFID、图像识别、称重、位移。其中，最为常用的就是RFID，因为基本没有技术门槛，买现成组件拼装即可。比较有技术含量的是图像识别，但图像识别多数用的开源技术，没有技术壁垒。七加购使用自主研发的称重、动态加AI决策脑识别技术是目前技术含量最高、识别速度最快最准确、可选择商品最全的解决方案。</p>
          </div>
        </div>
      </section>

      <section>
        <header class="header">技术层面</header>
        <p class="subtitle">Technical level</p>
        <img src="/static/about-technical.png"/>
        <div class="row technical">
          <div class="col-sm">
            <p>通过AI赋能，实现了动态视觉识别和重力感应互相加持的双重互补技术。商品的识别准确率得到了提高，用户不论是同时拿取多少件商品，又同时放回去多少件商品，系统都能准确记录。</p>
            <p>商品识别上，机器也已经能够支持超过1000种商品品类识别，并实现4路摄像头实时拍摄扫描，基于视频跟踪的图像序列动态商品识别算法，融合重力感应的动态规划, 通过模型裁剪、二值化等方法，在边缘服务器上实现模型推导加速，结合视觉识别和多种传感器技术，多模型联合决策，保证搜索准确率99%。</p>
            <p>多人同时从柜子中拿取商品，货柜也可同时识别商品信息，在货柜顶部LED显示屏与手机中展示。当关上货柜门时，系统就已从绑定的账户扣款。识别过程仅1秒，快速准确。从开门取货到关门结账，真正实现无感支付，真正实现完美体验。</p>
          </div>
          <div class="col-sm right">
            <p>国内最早投入智能无人货柜研发和量产的品牌之一</p>
            <p>国内第一台非rfid智能货柜</p>
            <p>国内第一台动态识别智能货柜</p>
            <p>国内第一台混合识别方式的AI智能货柜</p>
            <p>未来我们将继续领跑中国新零售领域人工智能方向</p>
            <br/>
            <p>第一代智能货柜在2017年1月正式投入使用，该货柜为重力感应智能货柜</p>
            <p>第二代设备则是以纯视觉柜的形式出现，提升了货品的种类识别率</p>
            <p>第三代则融合了前两代的综合能力。增加了半标品、非标品的识别</p>
            <p>能力与准确度，增加了可售卖商品类目。</p>
            <br/>
            <p>弦熵科技三个方向：</p>
            <p>无人货柜产品升级    新零售消费场景改造    为传统零售行业赋能。</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#page-about {
  background-color: #fafafa;
  font-size: 14px;
  color: #2f292c;

  img {
    max-width: 100%;
  }
  .header {
    margin-top: 60px;
    font-size: 32px;
    color: #333333;
  }
  .subtitle {
    font-size: 14px;
    color: #888888;
  }
  .market, .technical {
    padding: 40px 0;
    text-align: left;
    p {
      line-height: 30px;
      text-indent: 2em;
    }
  }
  .technical .right {
    padding-top: 15px;
    p {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/About.vue